import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';

import './navbar.css';

const NavBar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [isPatrimonioOpen, setIsPatrimonioOpen] = useState(false)
  const patrimonioRef = useRef<HTMLLIElement | null>(null)
  const location = useLocation()

  useEffect(() => {
    const onScroll = () => {
      document.body.classList.toggle('header-scrolled', window.scrollY > 90)
    }

    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', onScroll)
      document.body.classList.remove('header-scrolled')
    }
  }, [])

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 768) {
        setIsMobileMenuOpen(false)
        setIsPatrimonioOpen(false)
      }
    }

    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  useEffect(() => {
    setIsMobileMenuOpen(false)
    setIsPatrimonioOpen(false)

    const activeElement = document.activeElement
    if (activeElement instanceof HTMLElement) {
      activeElement.blur()
    }
  }, [location.pathname])

  // Close Patrimonio submenu when clicking outside
  useEffect(() => {
    const onDocClick = (ev: MouseEvent) => {
      const target = ev.target as Node | null
      if (!patrimonioRef.current) return
      if (isPatrimonioOpen && target && !patrimonioRef.current.contains(target)) {
        setIsPatrimonioOpen(false)
      }
    }

    document.addEventListener('mousedown', onDocClick)
    return () => document.removeEventListener('mousedown', onDocClick)
  }, [isPatrimonioOpen])

  return (
    <header className="top-bar-mockup" role="banner">
      <div className="top-bar-inner">
        <Link className="home" to="/">
          <img
            className="logo"
            src="https://fundaciongasco.cl/wp-content/themes/fundacion-gasco/images/logo-fundacion-gasco.svg"
            alt="Logo Fundación Gasco"
          />
        </Link>

        <button
          className={`menu-trigger ${isMobileMenuOpen ? 'active' : ''}`}
          type="button"
          aria-label="Abrir menú"
          aria-expanded={isMobileMenuOpen}
          aria-controls="main-menu"
          onClick={() => setIsMobileMenuOpen((current) => !current)}
        >
          Menú
        </button>

        <nav
          id="main-menu"
          className={`nav-top ${isMobileMenuOpen ? 'active' : ''}`}
          aria-label="Menú principal"
        >
          <ul className="menu-top">
            <li>
              <Link to="/quienes-somos">Quienes Somos</Link>
            </li>
            <li>
              <a href="https://fundaciongasco.cl/sala-gasco/">Sala Gasco</a>
            </li>
            <li>
              <a href="https://fundaciongasco.cl/gascoeduca/">GascoEduca</a>
            </li>
            <li ref={patrimonioRef} className={`has-submenu ${isPatrimonioOpen ? 'is-open' : ''}`}>
              <button
                className="submenu-trigger"
                type="button"
                aria-label="Abrir submenú de Patrimonio"
                aria-expanded={isPatrimonioOpen}
                onClick={() => setIsPatrimonioOpen((current) => !current)}
              >
                Patrimonio
              </button>
              <button
                className="submenu-toggle"
                type="button"
                aria-label="Abrir submenú de Patrimonio"
                aria-expanded={isPatrimonioOpen}
                onClick={() => setIsPatrimonioOpen((current) => !current)}
              >
                ▾
              </button>
              <ul className="submenu">
                <li>
                  <Link to="/edificio-corporativo" onClick={() => setIsPatrimonioOpen(false)}>Edificio Gasco</Link>
                </li>
                <li>
                  <Link to="/archivo-patrimonial" onClick={() => setIsPatrimonioOpen(false)}>Archivo Patrimonial Gasco</Link>
                </li>
                <li>
                  <Link to="/publicidad-para-una-historia" onClick={() => setIsPatrimonioOpen(false)}>Publicidad para una historia</Link>
                </li>
                <li>
                  <Link to="/pioneros-de-la-energia" onClick={() => setIsPatrimonioOpen(false)}>Pioneros de la energía</Link>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  )
}

export default NavBar;